import styled from 'styled-components';
import { rem } from '@/styles/theme';
import { Hr } from '@/components/atoms';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
  padding: ${rem(10)} ${rem(18)};
  ${({ theme }) => theme.media.fold`
    padding: ${rem(8)} ${rem(24)};
    gap: ${rem(16)};
  `}}
`;
export const TitleArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(2)};
`;

export const LabelArea = styled.div`
  display: flex;
  gap: ${rem(12)};
  align-items: center;
  ${({ theme }) => theme.media.fold`
    flex-direction: column;
    gap: ${rem(2)};
    align-items: flex-start;
  `}
`;

export const Label = styled.div`
  display: flex;
  gap: ${rem(5)};
`;

export const FooterArea = styled.div``;

export const Description = styled.div`
  margin-bottom: ${rem(2)};
`;

export const DescriptionRed = styled.div`
  margin-bottom: ${rem(2)};
`;

export const DescriptionGray = styled.div`
  margin-top: ${rem(8)};
`;

export const BottomLine = styled(Hr)`
  margin-top: ${rem(28)};
  ${({ theme }) => theme.media.fold`
    margin-top: ${rem(22)};
  `}}
`;
